$(document).ready(() => {
    ($('.date-picker-shamsi') as any).persianDatepicker({
        cellWidth: 30,
        cellHeight: 25,
        persianNumbers: false,
    });
    $('.date-picker-shamsi').attr('autocomplete', 'off');
});
